import { message } from 'antd';
import { setApiNotifier } from './uiNotify';

/**
 * WEB-1988 — кабинетный показчик сообщений HTTP-клиента (Ant Design).
 *
 * Единственное место, где `api/client.ts` снова встречается с antd, и живёт
 * оно на стороне КАБИНЕТА: вызов стоит в `src/main.tsx` до первого рендера,
 * чтобы даже самый ранний отказ сервера («сессия истекла») дошёл до человека
 * тостом, как и раньше. Публичный вход этот модуль не импортирует — там
 * сообщений кабинета не бывает.
 *
 * Парность держится тестом `antdApiNotifier.test.ts` (конец «клиент»: в
 * client.ts нет antd; конец «кабинет»: main.tsx зовёт эту функцию).
 */
export function installAntdApiNotifier(): void {
  setApiNotifier({
    warning: (text: string) => message.warning(text),
    error: (text: string) => message.error(text),
  });
}
